import { render, staticRenderFns } from "./BrandName.ts.vue?vue&type=template&id=442a6657"
import script from "./BrandName.ts.vue?vue&type=script&lang=ts"
export * from "./BrandName.ts.vue?vue&type=script&lang=ts"
import style0 from "./BrandName.ts.vue?vue&type=style&index=0&id=442a6657&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports